import { gqlClient } from '../../components/AppProvider';
import { Person } from '../../gql-types.generated';
import { queryApteanAdminUsers } from './QueryApteanAdminUsers';
import { AppDispatch, AppThunk } from '../../store';
import { decrementRequestsInFlight, incrementRequestsInFlight } from '../app/AppSlice';
import { fetchError, fetchApteanAdminUsersSuccess } from './ApteanAdminUsersSlice';

export const fetchApteanAdminUsers =
  (): AppThunk =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(incrementRequestsInFlight());

    try {
      const userList = await queryApteanAdminUsers(gqlClient);
      if (userList) {
        dispatch(fetchApteanAdminUsersSuccess(userList as Person[]));
      }
      dispatch(decrementRequestsInFlight());
    } catch (e) {
      dispatch(fetchError(e));
      dispatch(decrementRequestsInFlight());
    }
  };
